import React from 'react';
import { Navbar, Socials, Wallet } from './components';
import './Header.css';

interface HeaderProps {
  isConnected: boolean;
  userAddress: string;
  onConnect: () => void;
  onDisconnect: () => void;
}

export const Header: React.FC<HeaderProps> = (props) => (
  <header className="app-header">
    <Socials />
    <Navbar />
    <Wallet {...props} />
  </header>
);
